import { JSONData } from '../data/JSONData';
import axios from 'axios';
import { AxiosHeader } from '../header/AxiosHeader';
/**
 * Implementa a interface de request para fazer uso do método POST do AXIOS
 */
export class AxiosPost {
    //Construtor, onde pode ou não passar um header extra
    constructor(data) {
        this.axiosClient = axios.create();
        this.url = data.url;
        this.data = data.data || new JSONData();
        this.header = data.header || new AxiosHeader();
        this.responseType = data.responseType || 'json';
        this.timeout = data.timeout || 30000;
    }
    //Faz a requisição usando o Axios
    buildRequest() {
        return this.axiosClient.post(this.url.buildUrl(), this.data.data, {
            responseType: this.responseType,
            timeout: this.timeout,
            /*headers não esta funcionando da maneira correta, retornando undefined*/
            headers: this.data.setHeader(this.header),
        });
    }
}
